export const joinUrl = (
  base: string | undefined,
  suffix: string | undefined,
): string => {
  const cleanBaseStr = base ?? "";
  const cleanSuffixStr = suffix ?? "";

  if (!cleanBaseStr) return cleanSuffixStr;
  if (!cleanSuffixStr) return cleanBaseStr;

  const cleanBase = cleanBaseStr.endsWith("/")
    ? cleanBaseStr.slice(0, -1)
    : cleanBaseStr;

  let cleanSuffix = cleanSuffixStr.startsWith("/")
    ? cleanSuffixStr.slice(1)
    : cleanSuffixStr;

  if (cleanSuffix.endsWith("/")) {
    cleanSuffix = cleanSuffix.slice(0, -1);
  }

  return `${cleanBase}/${cleanSuffix}`;
};
